import { Account } from '@cliengo/mfe-utils/types';
import { getUrls } from '@cliengo/mfe-utils/utils';

import {
  CampaignsIcon,
  ChatbotIcon,
  ContactsIcon,
  DashboardIcon,
  InboxIcon,
  MetricsIcon,
  TeamIcon,
} from '../Icons';

import { NavItem } from './NavItem';

import { useTranslate } from '@/hooks';
import { CliengoLogo } from '@/layouts/components/CliengoLogo';
import { Show } from '@/components/utils';
import * as events from '@/utils/eventTracker';

interface NavItemsProps {
  account: Account;
}

export const NavItems = ({ account }: NavItemsProps) => {
  const { t } = useTranslate('navItems');

  return (
    <>
      {/* Home */}
      <NavItem
        onClick={events.goToHome}
        to="/"
        icon={<CliengoLogo />}
        label=""
      />

      {/* Dashboard */}
      <NavItem
        onClick={events.goToHome}
        to="/home"
        icon={<DashboardIcon />}
        label="Dashboard"
      />

      {/* Chatbot */}
      <NavItem
        to="/chatbot"
        icon={<ChatbotIcon />}
        label="Chatbot"
        onClick={events.goToChatbots}
        withPermissions={['websites_read', 'websites_write', 'admin']}
      />

      {/* Inbox */}
      <NavItem
        to="/live"
        icon={<InboxIcon />}
        onClick={events.goToInbox}
        label="Inbox"
        withPermissions={['chat_talk', 'reseller_admin', 'admin']}
      />

      {/* Contacts */}
      <NavItem
        to={`${getUrls().LEGACY_CRM_URL}/crm/contacts`}
        icon={<ContactsIcon />}
        label={t('contacts')}
        onClick={events.goToContacs}
        target="_blank"
        withPermissions={[
          'clients_write',
          'clients_read_assigned',
          'clients_write_assigned',
          'clients_read',
          'admin',
        ]}
      />

      {/* Team */}
      <NavItem
        to={`${getUrls().LEGACY_CRM_URL}/account/users`}
        icon={<TeamIcon />}
        onClick={events.goToTeam}
        withPermissions={['users_write', 'users_read', 'admin']}
        label={t('team')}
        target="_blank"
      />

      {/* Campañas */}
      <NavItem
        to="/campaigns"
        icon={<CampaignsIcon />}
        label={t('campaigns')}
        onClick={events.goToCompaigns}
        withPermissions={['websites_read', 'websites_write', 'admin']}
      />

      {/* Reportes */}
      <NavItem
        to="/reports"
        onClick={events.goToReports}
        icon={<MetricsIcon />}
        withPermissions={['reports_write', 'admin']}
        label={t('reports')}
      />

      {/* Afiliados */}
      <Show when={Boolean(account?.affiliateProgramCode)}>
        <NavItem
          to="/affiliates"
          icon={<TeamIcon />}
          label={t('affiliates')}
          onClick={events.goToAffiliates}
          withPermissions={['admin']}
        />
      </Show>
    </>
  );
};
